import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = true;

const slice = createSlice({
  name: '$enableGuestOrdering',
  initialState,
  reducers: {
    setEnableGuestOrdering(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableGuestOrdering } = slice.actions;
export default slice.reducer;
